<template>
  <div id="app">
    <div class="banner">
      <header>
        <img src="@/assets/image/logo.png" alt="" />
      </header>
      <div class="main">
        <router-view />
      </div>
    </div>
     <footer class="footer">
       <div class="footw">
        <div class="item tl">
            <div class="flogo" style="border-right:none; width:272px;margin-top:-24px;">
                <img src="@/assets/image/footLogo.png">
            </div>
        </div>
        <div class="item">
            <div class="fotact"><em>联系我们</em>&nbsp;&nbsp;/&nbsp;&nbsp;<span>CONTACT</span></div>
            <div class="folist">
                <div class="text"><em>地址：</em><span>天津市东丽区先锋东路68号</span></div>
                <!-- div class="text"><em>网址：</em><span>www.catarc.info</span></div -->
                <div class="text"><em>邮箱：</em><span>adc@catarc.ac.cn</span></div>
                <div class="text"><em>电话：</em><span>022-84379795</span></div>
            </div>
        </div>

        <div class="item tr">
            <div class="ever">
                <div class="evertit">微信服务号</div>
              <img src="@/assets/image/fuwu.jpg" style="width:90px;height:90px;margin-top:5px;">
            
            </div>
            <div class="ever">
                <div class="evertit">微信订阅号</div>
               <img src="@/assets/image/dingyue.jpg" style="width:90px;height:90px;margin-top:5px;">
               
            </div>
        </div>
        <div class="clear"></div>
    </div>
     </footer>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
html,body{
  margin: 0;
  padding: 0;
}
#app {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  width: 100%;
}
header img {
  height: 52px;
}
.banner{
  width: 1200px;
  flex:1 1 auto;
}
.footer {
    padding: 22px 0px;
    background: #434343;
    color: #fff;
    font-size: 14px;
    width: 100%;
}
.footer .footw {
    display: block;
    justify-content: center;
    vertical-align: top;
    width: 1000px;
    margin: 0px auto;
    max-width: 100%;
}
.footer .item.tl {
    height: 95px;
}

.footer .item {
    width: 33.33%;
    float: left;
}
.clear {
    display: block;
    clear: both;
    font-size: 0px;
    height: 0px;
    line-height: 0px;
    width: 0px;
    margin: 0px;
    padding: 0px;
    overflow: hidden;
}
.footer .item .flogo {
    text-align: center;
    border-right: 1px solid #717171;
    display: inline-block;
    padding: 0px 5%;
    box-sizing: border-box;
}
.footer .item .fotact {
    font-size: 16px;
}
.footer .item .fotact span {
    font-size: 12px;
}
.footer .item .folist .text {
    margin-top: 10px;
}
.footer .item .ever {
    text-align: center;
    display: inline-block;
    margin: 0px 1%;
}
.footer .item .evertit {
    font-size: 16px;
}
.footer img {
    border: 0;
    max-width: 100%;
}
</style>
